(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const select = root.querySelector('[data-real-variant]');
    const picker = root.querySelector('[data-option-picker]');
    const groups = [...picker.querySelectorAll('[data-option-position]')];
    const variants = [...select.options].map(option => ({ option, values: JSON.parse(option.dataset.options) }));
    const addButton = root.querySelector('[data-add-to-cart]');
    const dynamicCheckout = root.querySelector('[data-dynamic-checkout]');
    const sticky = root.querySelector('[data-sticky-purchase]');
    function syncSticky() {
      if (!sticky) return;
      const option = select.selectedOptions[0];
      const quantity = root.querySelector('.quantity').value;
      const values = groups.map(group => group.querySelector('input:checked')?.value).filter(Boolean);
      sticky.querySelector('[data-sticky-variant]').textContent = values.join(' / ') + ' · ×' + quantity;
      sticky.querySelector('[data-sticky-price]').textContent = option?.dataset.price || '';
      const button = sticky.querySelector('[data-sticky-add]');
      button.disabled = addButton.disabled;
      button.textContent = addButton.textContent;
    }
    function showImage(id) {
      if (!id || !root.querySelector('[data-product-photo][data-image-id="' + id + '"]')) return;
      root.querySelectorAll('[data-product-photo]').forEach(photo => { photo.hidden = photo.dataset.imageId !== id; });
      root.querySelectorAll('[data-show-image]').forEach(button => {
        const selected = button.dataset.showImage === id;
        button.setAttribute('aria-pressed', String(selected));
        if (selected) {
          const strip = button.parentElement;
          const buttonBox = button.getBoundingClientRect();
          const stripBox = strip.getBoundingClientRect();
          if (buttonBox.left < stripBox.left) strip.scrollLeft += buttonBox.left - stripBox.left;
          else if (buttonBox.right > stripBox.right) strip.scrollLeft += buttonBox.right - stripBox.right;
        }
      });
    }
    function syncVariant() {
      const option = select.selectedOptions[0];
      if (!option) return;
      const values = JSON.parse(option.dataset.options);
      groups.forEach((group, index) => {
        group.querySelectorAll('input').forEach(input => { input.checked = input.value === values[index]; });
        group.querySelector('[data-option-label]').textContent = values[index];
      });
      root.querySelector('[data-current-price]').textContent = option.dataset.price;
      addButton.disabled = option.dataset.available !== 'true';
      addButton.textContent = addButton.disabled ? addButton.dataset.unavailable : addButton.dataset.available;
      if (dynamicCheckout) dynamicCheckout.hidden = addButton.disabled;
      root.querySelector('[data-variant-status]').textContent = values.join(' / ') + ' · ' + option.dataset.price;
      showImage(option.dataset.image);
      syncSticky();
    }
    picker.hidden = false;
    root.querySelector('[data-native-variant]').hidden = true;
    const thumbnails = root.querySelector('[data-gallery-thumbnails]');
    if (thumbnails) thumbnails.hidden = false;
    syncVariant();
    if (sticky && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      });
      observer.observe(addButton);
    }
    root.addEventListener('input', event => {
      if (event.target.matches('.quantity')) syncSticky();
    });
    root.addEventListener('change', event => {
      if (event.target.matches('[data-option-picker] input')) {
        const values = groups.map(group => group.querySelector('input:checked')?.value);
        const match = variants.find(variant => variant.values.every((value, index) => value === values[index]));
        if (!match) {
          addButton.disabled = true;
          addButton.textContent = addButton.dataset.unavailable;
          if (dynamicCheckout) dynamicCheckout.hidden = true;
          syncSticky();
          return;
        }
        select.value = match.option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (event.target === select) {
        syncVariant();
        const url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        history.replaceState({}, '', url);
      }
    });
    root.addEventListener('click', event => {
      const thumb = event.target.closest('[data-show-image]');
      if (thumb) showImage(thumb.dataset.showImage);
      const sizeLink = event.target.closest('[data-open-size-guide]');
      if (sizeLink) root.querySelector(sizeLink.getAttribute('href')).open = true;
    });
  }
  function initializeAll(scope) { scope.querySelectorAll('[data-product-section]').forEach(initialize); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(document));
  else initializeAll(document);
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
